import React from "react";
import { css } from "emotion";
import { useNewOffer } from "../../../js/context/new-offer";
import { defaultStyle } from "./style";
import { intFormat, formatCurrency } from "../utils/formats";

const EditOfferHeader = () => {
	const { editOffer } = useNewOffer();

	if (!editOffer || !editOffer.id) {
		return null;
	}

	const { quant, price, fidelity } = editOffer;
	const { airlineName, name } = fidelity;

	return (
		<div
			className={css`
				${defaultStyle};
			`}
		>
			<h3>Edição de oferta</h3>
			<span>
				{name} - {airlineName} • {intFormat(quant)} milhas • R$ {formatCurrency(price)}
			</span>
		</div>
	);
};

export default EditOfferHeader;
